import React from 'react';

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';

import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';

import IndentedCardHeader from '../../../../../components/IndentedCardHeader/IndentedCardHeader.js';
import IndentedCardContent from '../../../../../components/IndentedCardContent/IndentedCardContent.js';
import ContentRow from '../../../../../components/ContentRow/ContentRow.js';
import ToggleButton from '../../../../../components/ToggleButton/ToggleButton.js';
import {
  getString,
  stringToDateShortLeadingZero,
} from '../../../../../helpers/stringHelpers.js';

import preferencesAPI from '../../../../../api/preferences';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';
import { string } from 'yup';

const stringsComponent = 'notifications';

class NotificationsCard extends React.Component {
  constructor(props) {
    super(props);

    const { preferencesData, newNotificationPreferences } = this.props;

    // Try to find an existing notification preference from either the current
    // state/session (newNotificationPreferences which have a higher priority),
    // or directly from the preferences API.
    const notificationsEmailPreference =
      newNotificationPreferences.find(
        (pref) => pref.key == 'notifications-email-bool'
      ) ||
      preferencesData.find((pref) => pref.key == 'notifications-email-bool');

    const notificationsSmsPreference =
      newNotificationPreferences.find(
        (pref) => pref.key == 'notifications-sms-bool'
      ) || preferencesData.find((pref) => pref.key == 'notifications-sms-bool');

    const notificationsEmail = notificationsEmailPreference
      ? notificationsEmailPreference.value == 'true'
        ? true
        : false
      : false;

    const notificationsSms = notificationsSmsPreference
      ? notificationsSmsPreference.value == 'true'
        ? true
        : false
      : false;

    this.state = {
      notificationsEmail: notificationsEmail,
      notificationsSms: notificationsSms,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { createPreferences } = this.props;

    if (prevState.notificationsEmail != this.state.notificationsEmail) {
      createPreferences(
        {
          preferences: [
            {
              key: 'notifications-email-bool',
              value: this.state.notificationsEmail ? 'true' : 'false',
            },
          ],
        },
        true
      );
    }
    if (prevState.notificationsSms != this.state.notificationsSms) {
      createPreferences(
        {
          preferences: [
            {
              key: 'notifications-sms-bool',
              value: this.state.notificationsSms ? 'true' : 'false',
            },
          ],
        },
        true
      );
    }
  }

  render() {
    const { classes, contactData } = this.props;

    const icon = <SmsOutlinedIcon />;

    return (
      <div className={classes.root}>
        <Hidden mdUp>
          <div>
            <div className={classes.header}>
              <SmsOutlinedIcon className={`${classes.icon} ItemIcon`} />
              <Typography variant="h3">
                {getString(stringsComponent, 'NOTIFICATIONS_SETTINGS')}
              </Typography>
            </div>
            {notificationsEmailEnabled ? (
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <div className={classes.iconFieldSubWrapper}>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'EMAIL_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {contactData.email
                          ? contactData.email
                          : getString(stringsComponent, 'NO_EMAIL_LABEL')}
                        <br />
                        <a href="#/profile/Contact-Details">
                          {getString(stringsComponent, 'UPDATE_LABEL')}
                        </a>
                      </Typography>
                    </ContentRow>
                  </div>
                  <div className={classes.toggleWrapper}>
                    <ToggleButton
                      toggleState={this.state.notificationsEmail}
                      onToggle={() => {
                        if (contactData.email) {
                          this.setState({
                            notificationsEmail: !this.state.notificationsEmail,
                          });
                        }
                      }}
                      showDisabled={!contactData.email}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            <br />
            {notificationsSMSEnabled ? (
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'MOBILE_TEXT_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {contactData.mobilePhone
                          ? contactData.mobilePhone
                          : getString(stringsComponent, 'NO_MOBILE_LABEL')}
                        <br />
                        <a href="#/profile/Contact-Details">
                          {getString(stringsComponent, 'UPDATE_LABEL')}
                        </a>
                      </Typography>
                    </ContentRow>
                  </div>
                  <div className={classes.toggleWrapper}>
                    <ToggleButton
                      toggleState={this.state.notificationsSms}
                      onToggle={() => {
                        if (contactData.mobilePhone) {
                          this.setState({
                            notificationsSms: !this.state.notificationsSms,
                          });
                        }
                      }}
                      showDisabled={!contactData.mobilePhone}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </Hidden>
        <Hidden smDown>
          <Card className="Card">
            <IndentedCardHeader
              title={
                <Typography variant="h3">
                  {getString(stringsComponent, 'NOTIFICATIONS_SETTINGS')}
                </Typography>
              }
              avatar={icon}
              classes={{
                avatar: classes.avatar,
              }}
            />
            <IndentedCardContent
              body={
                <div className={classes.negativeTopMargin}>
                  {notificationsEmailEnabled ? (
                    <div className={classes.line}>
                      <div className={classes.iconFieldWrapper}>
                        <div>
                          <Typography className={classes.label}>
                            {getString(stringsComponent, 'EMAIL_LABEL')}
                          </Typography>
                          <Typography className={classes.value}>
                            {contactData.email
                              ? contactData.email
                              : getString(
                                  stringsComponent,
                                  'NO_EMAIL_LABEL'
                                )}{' '}
                            &nbsp; <span className={classes.divider}>|</span>{' '}
                            &nbsp;{' '}
                            <a href="#/profile/Contact-Details">
                              {getString(stringsComponent, 'UPDATE_LABEL')}
                            </a>
                          </Typography>
                        </div>
                        <div className={classes.toggleWrapper}>
                          <ToggleButton
                            toggleState={this.state.notificationsEmail}
                            onToggle={() => {
                              if (contactData.email) {
                                this.setState({
                                  notificationsEmail:
                                    !this.state.notificationsEmail,
                                });
                              }
                            }}
                            showDisabled={!contactData.email}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <br />
                  {notificationsSMSEnabled ? (
                    <div className={classes.line}>
                      <div className={classes.iconFieldWrapper}>
                        <div>
                          <Typography className={classes.label}>
                            {getString(stringsComponent, 'MOBILE_TEXT_LABEL')}
                          </Typography>
                          <Typography className={classes.value}>
                            {contactData.mobilePhone
                              ? contactData.mobilePhone
                              : getString(
                                  stringsComponent,
                                  'NO_MOBILE_LABEL'
                                )}{' '}
                            &nbsp; <span className={classes.divider}>|</span>{' '}
                            &nbsp;{' '}
                            <a href="#/profile/Contact-Details">
                              {getString(stringsComponent, 'UPDATE_LABEL')}
                            </a>
                          </Typography>
                        </div>
                        <div className={classes.toggleWrapper}>
                          <ToggleButton
                            toggleState={this.state.notificationsSms}
                            onToggle={() => {
                              if (contactData.mobilePhone) {
                                this.setState({
                                  notificationsSms:
                                    !this.state.notificationsSms,
                                });
                              }
                            }}
                            showDisabled={!contactData.mobilePhone}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              }
            />
          </Card>
        </Hidden>
      </div>
    );
  }
}

NotificationsCard.propTypes = {};

NotificationsCard.defaultProps = {};

export default withStyles(styles, { withTheme: true })(NotificationsCard);
